import { getUserProfileOptionsStore } from '../modules/userProfileOptions';

export const UserProfileOptionsStore = getUserProfileOptionsStore();
